<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Dashboard</span><br/>
      <span style="font-style: italic; font-size: 18px">overview of integration features and processing events</span>
    </div>

    <div v-if="!(user.role == 'manager' || user.role == 'dispatch' || user.role == 'garage' || user.role == 'wash-bay')" style="position: relative" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
    </div>
    <div style="margin: 20px;" v-if="!loading">
      <template v-if="(user.role == 'manager' || user.role == 'dispatch' || user.role == 'garage' || user.role == 'wash-bay')">
        <div class="row-none" style="margin-bottom:20px; font-weight: bold; font-size: 20px;">
          <div class="col" style="font-size: 20px; min-width: 250px; max-width: 250px; color: white; background-color: var(--fi-rail-accent)">Company Overview</div>
          <div class="col" style="border: 1px solid grey;">Vehicles: {{summary.vehicle_count}}</div>
          <div class="col" style="border: 1px solid grey;">Name: {{summary.tenant_name}}</div>
          <div class="col" style="border: 1px solid grey;">Users: {{summary.user_count}}</div>
          <div v-if="summary.vehicle_yards" class="col" style="border: 1px solid grey;">Registered Yards: {{summary.vehicle_yards.length}}</div>
          <div class="col" style="border: 1px solid grey;">TZ: {{summary.timezone}}</div>
          <div v-if="summary.aws_phone_number" class="col" style="border: 1px solid grey;">SMS #: {{summary.aws_phone_number}}</div>
          <div class="col" style="border: 1px solid grey;">{{summary.tenant_type}} / <a target="_blank" :href="summary.samsara_link">{{  summary.telematics_type }}</a></div>
        </div>
      </template>

      <template v-else>
        <div v-if="summary.vehicle_count" class="row-none" style="margin-bottom:20px; font-weight: bold; font-size: 20px;">
          <div class="col" style="font-size: 20px; min-width: 250px; max-width: 250px; color: white; background-color: var(--fi-rail-accent)">Company Overview</div>
          <div class="col" style="border: 1px solid grey;">Vehicles: {{summary.vehicle_count}}</div>
          <div class="col" style="border: 1px solid grey;">Drivers: {{summary.driver_count}}</div>
          <div class="col" style="border: 1px solid grey;">Users: {{summary.user_count}}</div>
          <div class="col" style="border: 1px solid grey;">TZ: {{summary.timezone}}</div>
          <div v-if="summary.aws_phone_number" class="col" style="border: 1px solid grey;">SMS #: {{summary.aws_phone_number | prettyPhoneNumber}}</div>
          <div v-if="summary.samsara_link" class="col" style="border: 1px solid grey;">{{summary.tenant_type}} / <a target="_blank" :href="summary.samsara_link">{{  summary.telematics_type }}</a></div>
          <div v-else class="col" style="border: 1px solid grey;">{{summary.tenant_type}} / {{ summary.telematics_type }}</div>
        </div>
        <div v-else class="row-none" style="margin-bottom:20px; font-weight: bold; font-size: 20px;">
          <div class="col" style="font-size: 20px; min-width: 250px; max-width: 250px; color: white; background-color: var(--fi-rail-accent)">Company Overview</div>
          <div class="col" style="border: 1px solid grey;">Name: {{summary.tenant_name}}</div>
          <div class="col" style="border: 1px solid grey;">Users: {{summary.user_count}}</div>
          <div v-if="summary.vehicle_yards" class="col" style="border: 1px solid grey;">Registered Yards: {{summary.vehicle_yards.length}}</div>
          <div class="col" style="border: 1px solid grey;">TZ: {{summary.timezone}}</div>
        </div>
        <div class="row-none" style="margin-bottom:20px; font-weight: bold; font-size: 18px;" v-if="summary.actuals_totals">
          <div class="col" style="font-size: 20px; min-width: 250px; max-width: 250px; color: white; background-color: var(--fi-rail-accent)">Monthly Actuals Totals</div>
          <div class="col" style="border: 1px solid grey;">Total: {{summary.actuals_totals.total_cnt}}</div>
          <div class="col" style="border: 1px solid grey;">Success: {{summary.actuals_totals.success_cnt}}</div>
          <div class="col" style="border: 1px solid grey;">Errors: {{summary.actuals_totals.error_cnt}}</div>
          <div class="col" style="border: 1px solid grey;">Cancelled: {{summary.actuals_totals.cancelled_cnt}}</div>
          <div class="col" style="border: 1px solid grey;">Unprocessed: {{summary.actuals_totals.unprocessed_cnt}}</div>
          <div v-if="summary.last_actuals_request_time" class="col-2" style="border: 1px solid grey;">Last Request: {{summary.last_actuals_request_time | formatDate}}</div>
        </div>
        <div class="row-none" style="margin-bottom:20px; font-weight: bold; font-size: 18px;" v-if="summary.alert_totals && summary.alert_totals.alert_cnt > 0">
          <div class="col" style="font-size: 20px; min-width: 250px; max-width: 250px; color: white; background-color: var(--fi-rail-accent)">Monthly Alert Totals</div>
          <div class="col" style="border: 1px solid grey;">Alert Count: {{summary.alert_totals.alert_cnt}}</div>
          <div class="col" style="border: 1px solid grey;">Late Alerts: {{summary.alert_totals.late_alert_cnt}}</div>
          <div class="col" style="border: 1px solid grey;">Trip Notifications: {{summary.alert_totals.trip_notification_cnt}}</div>
          <div class="col" style="border: 1px solid grey;">Emails Sent: {{summary.alert_totals.email_cnt}}</div>
          <div v-if="summary.alert_totals.msteams_cnt > 0" class="col" style="border: 1px solid grey;">MSTeams Sent: {{summary.alert_totals.msteams_cnt}}</div>
          <div v-if="summary.alert_totals.slack_cnt > 0" class="col" style="border: 1px solid grey;">MSTeams Sent: {{summary.alert_totals.slack_cnt}}</div>
        </div>
        <div class="row-none" style="font-weight: bold; font-size: 18px;" v-if="summary.alert_totals && summary.alert_totals.sms_cnt > 0">
          <div class="col" style="font-size: 20px; min-width: 250px; max-width: 250px; color: white; background-color: var(--fi-rail-accent)">Monthly SMS Stats</div>
          <div class="col" style="border: 1px solid grey;">Sent Cnt: {{summary.alert_totals.sms_cnt}} ({{ (summary.alert_totals.sms_cnt/summary.alert_totals.alert_cnt) | roundNumber(1)}} #s/msg)</div>
          <div v-if="summary.alert_totals.sms_cost && summary.alert_totals.sms_cost > 0" class="col" style="border: 1px solid grey;">Sent Units: {{summary.alert_totals.sms_unit_cnt}} ({{ (summary.alert_totals.sms_unit_cnt/summary.alert_totals.sms_cnt) | roundNumber(1)}}/msg)</div>
          <div v-if="summary.alert_totals.sms_cost && summary.alert_totals.sms_cost > 0" class="col" style="border: 1px solid grey;">Sent Cost: ${{summary.alert_totals.sms_cost}} (${{ (summary.alert_totals.sms_cost/summary.alert_totals.sms_cnt) | roundNumber(3)}}/msg)</div>
          <div v-if="summary.alert_totals.sms_inbound_cnt && summary.alert_totals.sms_inbound_cnt > 0" class="col" style="border: 1px solid grey;">Received Count: {{summary.alert_totals.sms_inbound_cnt}}</div>
          <div v-if="summary.alert_totals.sms_inbound_cnt && summary.alert_totals.sms_inbound_cnt > 0" class="col" style="border: 1px solid grey;">Received Cost: ${{summary.alert_totals.sms_inbound_cost}}</div>
        </div>

  <!--      <div class="row-none" style="font-weight: bold; font-size: 18px;" v-if="summary.license_totals">-->
  <!--        <div class="col" style="font-size: 20px; min-width: 250px; max-width: 250px; color: white; background-color: steelblue">Monthly License Costs</div>-->
  <!--      </div>-->

        <dashboard-chart v-if="actuals_chart_data" :loading="loading" :chart_data="actuals_chart_data" chart_type="LineChart"
                         graph_title="Actuals By Date" date_format="MM/dd"
                         graph_height="280" :curved="true"/>

        <dashboard-chart v-if="alerts_chart_data && summary.alert_totals && summary.alert_totals.alert_cnt > 0" :loading="loading" :chart_data="alerts_chart_data" chart_type="LineChart"
                         graph_title="Alerts By Date" date_format="MM/dd"
                         graph_height="280" :curved="true"/>

        <dashboard-chart v-if="booking_files_chart_data" :loading="loading" :chart_data="booking_files_chart_data" chart_type="LineChart"
                         graph_title="Booking Updates By Date" date_format="MM/dd"
                         graph_height="280" :curved="true"/>
      </template>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>
</template>
<script>
import {get_tenant_dashboard} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment'
import DashboardChart from './DashboardChart'
import { GChart } from 'vue-google-charts'
import {justDate} from "@/helpers/dates";

export default {
  name: 'dashboard',
  components: {
    DashboardChart,
    GChart
  },

  data() {
    return {
      admin_mode: false,
      actuals_chart_data: null,
      alerts_chart_data: null,
      booking_files_chart_data: null,
      details_fromDate: justDate(moment().subtract(1, 'days')),
      model: {},
      summary: {},
      loading: true,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        maxDate: moment().subtract(1, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      }
    }
  },
  async created() {
    this.check_features()
  },
  methods: {
    async check_features() {
      this.admin_mode = this.user.role == 'admin'
      this.actuals_chart_data = null
      this.alerts_chart_data = null
      this.booking_files_chart_data = null
      this.load_data()
    },
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_tenant_dashboard(this.user.tenant,moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data

        if (data.stats != null) {
          const daily = data.stats

          if (this.summary.actuals_totals != null && this.summary.actuals_totals.total_cnt > 0) {
            this.actuals_chart_data = [
              ['Date', 'Total Processed', 'Error', 'Success', 'Cancelled', 'Unprocessed'],
              ...(data.length !== 0 ? daily : [{date: new Date()}]).map(
                  ({date, stats = {}}) => [
                    moment(String(date)).format('MM/DD'), Number(stats.actuals.total_cnt || 0), Number(stats.actuals.error_cnt || 0), Number(stats.actuals.success_cnt || 0), Number(stats.actuals.cancelled_cnt || 0), Number(stats.actuals.unprocessed_cnt || 0)
                  ]
              )
            ]
          }

          if (this.summary.alert_totals != null && this.summary.alert_totals.alert_cnt > 0) {
            this.alerts_chart_data = [
              ['Date', 'Total Alerts', 'Late Alerts', 'Trip Notifications', 'Emails', 'SMS', 'Slack', 'MSTeams'],
              ...(data.length !== 0 ? daily : [{date: new Date()}]).map(
                  ({date, stats = {}}) => [
                    moment(String(date)).format('MM/DD'), Number(stats.alerts.alert_cnt || 0), Number(stats.alerts.late_alert_cnt || 0), Number(stats.alerts.trip_notification_cnt || 0), Number(stats.alerts.email_cnt || 0), Number(stats.alerts.sms_cnt || 0), Number(stats.alerts.slack_cnt || 0), Number(stats.alerts.msteams_cnt || 0),
                  ]
              )
            ]
          }

          this.booking_files_chart_data = [
            ['Date', 'Total Updates', 'Contract Updates', 'Charter Updates'],
            ...(data.length !== 0 ? daily : [{date: new Date()}]).map(
                ({date, stats = {}}) => [
                  moment(String(date)).format('MM/DD'), Number(stats.bookings.booking_update_total_cnt || 0), Number(stats.bookings.booking_update_contract_cnt || 0), Number(stats.bookings.booking_update_private_cnt || 0)
                ]
            )
          ]

        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    }
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      this.load_data();
    }
  }
}
</script>
<style>
.row-none {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col { border-radius: 5px; margin:2px}
.col-2 { border-radius: 5px; margin:2px}
.col-3 { border-radius: 5px; margin:2px}
.col-4 { border-radius: 5px; margin:2px}
</style>

